import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { Reveal } from "@/components/store/Reveal";
import { WEEK } from "@/constants/product";

export const WeeklyLoop = () => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start 80%", "end 60%"] });
  const scaleX = useTransform(scrollYProgress, [0, 1], [0, 1]);
  return (
    <section id="loop" ref={ref} className="bg-[var(--sage)] px-5 py-24 sm:px-10 sm:py-32" data-testid="loop-section">
      <div className="mx-auto max-w-[1360px]">
        <Reveal>
          <p className="text-xs font-semibold uppercase tracking-[0.22em] text-[var(--ink)]/75">The weekly loop</p>
          <h2 className="font-display mt-5 max-w-3xl text-4xl leading-[1.02] sm:text-6xl">Five steps you repeat every week, on paper.</h2>
        </Reveal>
        <div className="relative mt-16">
          <div className="absolute left-0 right-0 top-[1.4rem] hidden h-px bg-black/15 sm:block" />
          <motion.div style={{ scaleX }} className="absolute left-0 right-0 top-[1.4rem] hidden h-[2px] origin-left bg-[var(--ink)] sm:block" />
          <ol className="grid gap-10 sm:grid-cols-5 sm:gap-6">
            {WEEK.map((w, i) => (
              <Reveal key={w.day} delay={i * 0.08}>
                <li className="relative" data-testid={`loop-step-${i + 1}`}>
                  <span className="relative z-10 flex h-11 w-11 items-center justify-center rounded-full border border-black/20 bg-[var(--paper)] text-sm font-bold">{i + 1}</span>
                  <h3 className="font-display mt-6 text-3xl">{w.day}</h3>
                  <p className="mt-2 text-[var(--ink)]/75">{w.note}</p>
                </li>
              </Reveal>
            ))}
          </ol>
        </div>
      </div>
    </section>
  );
};
